import { render } from "./DateInput.vue?vue&type=template&id=f9a6994a"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"
script.render = render

export default script